import { useMutation } from "react-query"
import api from "../../client"
import { AddressBookCreatePayload, AddressBookCreateResponseData } from "../../types/address-book"

const postData = async (payload: AddressBookCreatePayload) => {
    const { data } = await api.post<AddressBookCreateResponseData>(
        `/address-book`,
        payload
    )
    return data
}

export const useAddressBookCreate = () => {
    return useMutation((payload: AddressBookCreatePayload) => {
        return postData(payload)
    })
}
